import { render, staticRenderFns } from "./transactionTypeChargesDetailsModal.vue?vue&type=template&id=abd789f6&scoped=true"
import script from "./transactionTypeChargesDetailsModal.vue?vue&type=script&lang=js"
export * from "./transactionTypeChargesDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./transactionTypeChargesDetailsModal.vue?vue&type=style&index=0&id=abd789f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd789f6",
  null
  
)

export default component.exports